import { useEditorProps } from '../../core/context/EditorPropsContext';
import { useFeatureEnabled } from '../../core/context/FeaturesContext';
import type { ImageUploadAdapter } from '../../core/context/IntegrationsContext';
import { useIntegrations } from '../../core/context/IntegrationsContext';

/** Upload/resolve for this editor: per-editor `features.images` callbacks win over the app integrations. */
export const useImageHandlers = (): Partial<ImageUploadAdapter> => {
  const enabled = useFeatureEnabled('images');
  const images = useEditorProps().features?.images;
  const { images: adapter } = useIntegrations();

  if (!enabled) return {};
  return { upload: images?.onUpload ?? adapter?.upload, resolve: images?.onResolve ?? adapter?.resolve };
};
